import React, { useContext as useContextCore } from 'react'
import { queries } from './graphql'
import { useParams } from 'react-router-dom'
import type { UseDocumentResult } from '@ztechapps/common.hook'
import { useDocument } from '@ztechapps/common.hook'
import type { Blog } from '@ztechapps/common.contract'

export type BlogItemProviderProps = {
  children: React.ReactNode
}

export type BlogItemContextType = {
  documentResult: UseDocumentResult<Blog>
  document: Blog
  loading: boolean
} & Omit<BlogItemProviderProps, 'children'>

const context = React.createContext<BlogItemContextType>({} as BlogItemContextType)
const CoreProvider = context.Provider

export const BlogItemProvider = ({ children, ...props }: BlogItemProviderProps) => {
  const params: any = useParams()
  const _id = params?._id
  const documentResult = useDocument<Blog>({ ...queries.singleConfig, _id, subscribeToUpdates: true })

  return (
    <CoreProvider
      value={{
        ...props,
        documentResult,
        document: documentResult?.document,
        loading: documentResult?.loading,
      }}
    >
      {children}
    </CoreProvider>
  )
}

export const useBlogItemContext = () => useContextCore(context)
